import { AnswerType } from '../../shared/enums/answer.enum';
import { Answer } from './answer.model';

export type SelfExamenQuestionAnswer = string;

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class SelfExamAnswer extends Answer {
  public answer: SelfExamenQuestionAnswer | undefined;

  constructor(id: string, type: AnswerType, answer?: SelfExamenQuestionAnswer) {
    super();
    this.id = id;
    this.type = type;
    this.answer = answer;
  }

  public static fromDto(dto: any): SelfExamAnswer {
    return new SelfExamAnswer(dto.id, dto.type, dto.answer);
  }
}
